export default __webpack_public_path__ + "static/media/around_us_logo.4e8e0a1d.svg";